import { AbstractSearchCriteria } from './abstract-search-criteria';

export class RoomTypeSearchCriteria  extends AbstractSearchCriteria {
    code: string = '';
    name: string = '';

}
